"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
require("./index.scss");
const InputText_1 = __importDefault(require("@Components/Fields/InputText"));
const Button_1 = require("@Components/Buttons/Button");
const Checkbox_1 = __importDefault(require("@Components/Selectors/Checkbox"));
const react_router_dom_1 = require("react-router-dom");
const validate_1 = require("@App/helpers/validate");
const get_date_iso_6801_1 = require("@App/helpers/get-date-iso-6801");
const navigation_1 = __importDefault(require("@App/navigation"));
const user_permissions_1 = require("@App/enum/user-permissions");
const contexts_1 = require("@App/contexts");
class AddNewUserSub extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "myUserGroups", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "firstName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "lastName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "email", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "firstNameError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "lastNameError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "emailError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "groupChecked", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "formType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'ADD'
        });
        Object.defineProperty(this, "destroyForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.setUsersGroup();
                this.firstName = '';
                this.lastName = '';
                this.email = '';
                this.emailError = '';
                this.groupChecked = false;
                this.context.rightsholderUserStore.destroyRightsHolderInviteInfo();
                this.changeFormTo('ADD');
            }
        });
        Object.defineProperty(this, "changeFormTo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (type) => {
                this.formType = type;
            }
        });
        Object.defineProperty(this, "onChangeFirstName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                if (!(0, validate_1.valueIsEmpty)(value)) {
                    this.firstName = value;
                }
                else {
                    this.firstName = '';
                }
                if (value && value.length > 60) {
                    this.firstNameError = 'Invalid value, max length 60';
                }
                else {
                    this.firstNameError = '';
                }
            }
        });
        Object.defineProperty(this, "onChangeLastName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                if (!(0, validate_1.valueIsEmpty)(value)) {
                    this.lastName = value;
                }
                else {
                    this.lastName = '';
                }
                if (value && value.length > 60) {
                    this.lastNameError = 'Invalid value, max length 60';
                }
                else {
                    this.lastNameError = '';
                }
            }
        });
        Object.defineProperty(this, "onChangeEmail", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                if (!(0, validate_1.valueIsEmpty)(value)) {
                    this.email = value.toLowerCase().trim();
                    this.emailValidate();
                }
                else {
                    this.email = '';
                }
                if (value && value.length > 2000) {
                    this.emailError = 'Invalid value, max length 2000';
                }
                else {
                    this.emailError = '';
                }
            }
        });
        Object.defineProperty(this, "emailValidate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (!(0, validate_1.emailIsValid)(this.email)) {
                    this.emailError = 'Please enter a valid email address';
                }
                else {
                    this.emailError = '';
                }
            }
        });
        Object.defineProperty(this, "setUsersGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const userGroupsCollection = this.context.userStore.permissionGroups;
                if (userGroupsCollection) {
                    this.myUserGroups = userGroupsCollection.map((item) => (Object.assign(Object.assign({}, item), { checked: false, disabled: false })));
                }
            }
        });
        Object.defineProperty(this, "onCheckGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (index) => {
                this.myUserGroups[index].checked = !this.myUserGroups[index].checked;
                this.groupChecked = !!this.myUserGroups.find((item) => item.checked);
                const superUserIsChecked = this.myUserGroups[index].name === user_permissions_1.PERMISSION_NAMES.super_user && this.myUserGroups[index].checked;
                this.superUserChecked(superUserIsChecked);
            }
        });
        Object.defineProperty(this, "superUserChecked", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (superUserIsChecked) => {
                this.myUserGroups = this.myUserGroups.map((item) => {
                    const otherItemsChecked = superUserIsChecked ? false : item.checked;
                    return Object.assign(Object.assign({}, item), { checked: item.name === user_permissions_1.PERMISSION_NAMES.super_user ? superUserIsChecked : otherItemsChecked, disabled: item.name !== user_permissions_1.PERMISSION_NAMES.super_user && superUserIsChecked });
                });
            }
        });
        Object.defineProperty(this, "onInvite", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                this.emailValidate();
                const currentRightsHolderId = this.context.rightsholderStore.currentRightsholderId;
                const groups = this.myUserGroups
                    .filter((item) => item.checked)
                    .map((item) => ({
                    name: item.name,
                }));
                const formData = {
                    firstName: this.firstName.trim(),
                    lastName: this.lastName.trim(),
                    email: this.email,
                    groups: groups,
                };
                if (currentRightsHolderId && !this.emailError) {
                    try {
                        this.context.preloaderStore.openTransparentPreloader(true);
                        yield this.context.rightsholderUserStore.inviteRightsholderUser(formData);
                        yield this.context.rightsholderUserStore.loadRightsholderUsers({
                            page: 1,
                            limit: 10,
                        });
                        this.context.preloaderStore.openTransparentPreloader(false);
                        this.context.popupStore.setAlertData('Invite sent!', false);
                        this.changeFormTo('CONFIRMED');
                    }
                    catch (error) {
                        this.context.popupStore.setAlertFromError(error);
                        this.context.preloaderStore.openTransparentPreloader(false);
                    }
                }
            })
        });
        (0, mobx_1.makeObservable)(this, {
            myUserGroups: mobx_1.observable,
            firstName: mobx_1.observable,
            lastName: mobx_1.observable,
            email: mobx_1.observable,
            firstNameError: mobx_1.observable,
            lastNameError: mobx_1.observable,
            emailError: mobx_1.observable,
            groupChecked: mobx_1.observable,
            formType: mobx_1.observable,
            destroyForm: mobx_1.action,
            changeFormTo: mobx_1.action,
            onChangeFirstName: mobx_1.action,
            onChangeLastName: mobx_1.action,
            onChangeEmail: mobx_1.action,
            emailValidate: mobx_1.action,
            setUsersGroup: mobx_1.action,
            onCheckGroup: mobx_1.action,
            superUserChecked: mobx_1.action,
        });
    }
    componentDidMount() {
        this.setUsersGroup();
    }
    componentWillUnmount() {
        this.destroyForm();
    }
    render() {
        const formIsReady = this.firstName &&
            this.lastName &&
            this.email &&
            !this.emailError &&
            !this.firstNameError &&
            !this.lastNameError &&
            this.groupChecked;
        const inviteInfo = this.context.rightsholderUserStore.rightsholderUserInviteInfo;
        const isInternal = this.context.userStore.isInternal;
        if (this.formType === 'ADD') {
            return (react_1.default.createElement("div", { className: "add-new-user-sub-form-component" },
                react_1.default.createElement("h2", null, "Add New User"),
                react_1.default.createElement("div", { className: 'inputs-field' },
                    react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'first-name', value: this.firstName, label: 'First Name', assistiveText: 'Required', errorMessage: this.firstNameError, onChange: this.onChangeFirstName }),
                    react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'last-name', value: this.lastName, label: 'Last Name', assistiveText: 'Required', errorMessage: this.lastNameError, onChange: this.onChangeLastName }),
                    react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'email', value: this.email, label: 'Email Address', assistiveText: 'Required', errorMessage: this.emailError, onChange: this.onChangeEmail })),
                react_1.default.createElement("br", null),
                react_1.default.createElement("h5", null, "User permission"),
                react_1.default.createElement("div", { className: 'permissions-group' }, this.myUserGroups.map((item, index) => {
                    let helperText = '';
                    if (item.name === 'Internal User') {
                        return;
                    }
                    else if (item.name === 'Copyright') {
                        helperText =
                            'Grants user access to copyright-related features only, such as ' +
                                'viewing, editing and creating works in the' +
                                " Member's catalog. Cannot see user permissions or banking information.";
                    }
                    else if (item.name === 'Finance') {
                        helperText =
                            'Grants user access to finance-related features only, such as ' +
                                'managing banking and tax information for a Member.' +
                                ' Cannot view, edit or create works.';
                    }
                    else if (item.name === 'Super User') {
                        helperText =
                            'Grants user full access. User can take all actions on works in the ' +
                                "Member's catalog, can manage User" +
                                ' Permissions and Member account information.';
                    }
                    return (react_1.default.createElement(Checkbox_1.default, { id: item.name, key: item.name, mainColor: true, onClick: () => this.onCheckGroup(index), checked: item.checked, text: item.name, disabled: item.disabled, labelInfo: helperText }));
                })),
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', disabled: !formIsReady || isInternal, onClick: this.onInvite }, "Invite")));
        }
        else if (this.formType === 'CONFIRMED' && inviteInfo) {
            return (react_1.default.createElement("div", { className: "add-new-user-sub-form-component" },
                react_1.default.createElement("h2", null, "Invite Sent!"),
                react_1.default.createElement("h5", { className: 'medium subtitle' }, "An invite to the portal has been sent to the email address provider"),
                react_1.default.createElement("br", null),
                react_1.default.createElement("h5", null, "Invited user"),
                react_1.default.createElement("div", { className: 'invited-user-card' },
                    react_1.default.createElement("div", { className: 'head' },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("h5", { title: inviteInfo.firstName + ' ' + inviteInfo.lastName },
                                inviteInfo.firstName,
                                " ",
                                inviteInfo.lastName),
                            react_1.default.createElement("p", { title: inviteInfo.email, className: 'small' }, inviteInfo.email)),
                        inviteInfo.id && (react_1.default.createElement(react_router_dom_1.Link, { to: navigation_1.default.rightholder.maintenance.userPermissionsProfile(this.context.rightsholderStore.currentRightsholderId, inviteInfo.id), className: 'blue-text link' }, "View"))),
                    react_1.default.createElement("div", { className: 'info-block' },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("p", { className: 'small bold' }, "GROUP"),
                            inviteInfo &&
                                inviteInfo.groups &&
                                inviteInfo.groups.map((item) => (react_1.default.createElement("p", { key: item.name, className: 'small' }, item.name)))),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("p", { className: 'small bold' }, "STATUS"),
                            react_1.default.createElement("p", { className: 'small' }, inviteInfo.verificationStatus)),
                        inviteInfo.invitationSentTimestamp ? (react_1.default.createElement("div", null,
                            react_1.default.createElement("p", { className: 'small bold' }, "DATE SENT"),
                            react_1.default.createElement("p", { className: 'small' }, (0, get_date_iso_6801_1.getDateFromIso)(inviteInfo.invitationSentTimestamp)))) : null)),
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: this.destroyForm }, "Add another user")));
        }
        else {
            return null;
        }
    }
}
exports.default = (0, mobx_react_1.observer)(AddNewUserSub);
AddNewUserSub.contextType = contexts_1.StoresContext;
